import React, { useEffect, useRef } from 'react';
import './Transcript.css';

// Sorted longest-first so phrases match before single words
const FILLER_PATTERN = new RegExp(
  '\\b(' + [
    'you know', 'i mean', 'sort of', 'kind of',
    'uh-huh', 'mm-hmm',
    'um', 'uh', 'hmm', 'mm', 'mhm', 'er', 'ah',
    'like', 'basically', 'actually', 'literally', 'yeah',
    'so', 'well', 'okay', 'right', 'gonna', 'wanna', 'gotta',
  ].join('|') + ')\\b',
  'gi'
);

function highlightFillers(text) {
  const parts = text.split(FILLER_PATTERN);
  return parts.map((part, i) => {
    if (FILLER_PATTERN.test(part)) {
      FILLER_PATTERN.lastIndex = 0; // reset stateful regex
      return <mark key={i} className="filler-word">{part}</mark>;
    }
    FILLER_PATTERN.lastIndex = 0;
    return part;
  });
}

function Transcript({ lines, interimText }) {
  const ref = useRef(null);
  const wordCount = lines.reduce(
    (n, l) => n + l.text.split(/\s+/).filter(Boolean).length, 0
  );

  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [lines, interimText]);

  return (
    <div className="transcript-panel">
      <div className="transcript-header">
        <h3>transcript</h3>
        {wordCount > 0 && (
          <span className="transcript-word-count">{wordCount} words</span>
        )}
      </div>
      <div className="transcript-content" ref={ref}>
        {lines.length === 0 && !interimText ? (
          <p className="transcript-empty">your speech will appear here...</p>
        ) : (
          <>
            {lines.map((line, i) => (
              <div key={i} className="transcript-line">
                {highlightFillers(line.text)}
              </div>
            ))}
            {interimText && (
              <div className="transcript-line transcript-interim">
                {interimText}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Transcript;
